import { AccountClosureApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const AccountClosureApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <AccountClosureApplication isEdit={isEdit} isCopy={isCopy}/>
);
